/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Search_QuotedInputs */

const en_us2_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.query}”`)
};

const pt_br2_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`«${i?.query}»`)
};

const es_419_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.query}”`)
};

const pt_pt2_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`«${i?.query}»`)
};

const fr_fr2_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`« ${i?.query} »`)
};

const de_de2_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.query}“`)
};

const it_it2_search_quoted = /** @type {(inputs: Search_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`«${i?.query}»`)
};

/**
* | output |
* | --- |
* | "“{query}”" |
*
* @param {Search_QuotedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_quoted = /** @type {((inputs: Search_QuotedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_QuotedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_quoted(inputs)
	if (locale === "es-419") return es_419_search_quoted(inputs)
	if (locale === "pt-PT") return pt_pt2_search_quoted(inputs)
	if (locale === "fr-FR") return fr_fr2_search_quoted(inputs)
	if (locale === "de-DE") return de_de2_search_quoted(inputs)
	if (locale === "it-IT") return it_it2_search_quoted(inputs)
	return en_us2_search_quoted(inputs)
});
export { search_quoted as "search.quoted" }